import Phaser from 'phaser'
import { DESIGN_HEIGHT, DESIGN_WIDTH } from './JKGame_dims'
import { JKGame_BootScene } from './scenes/JKGame_BootScene'
import { JKGame_CollectionScene } from './scenes/JKGame_CollectionScene'
import { JKGame_CombatScene } from './scenes/JKGame_CombatScene'
import { JKGame_ExploreScene } from './scenes/JKGame_ExploreScene'
import { JKGame_GachaScene } from './scenes/JKGame_GachaScene'
import { JKGame_LeaderboardScene } from './scenes/JKGame_LeaderboardScene'
import { JKGame_MenuScene } from './scenes/JKGame_MenuScene'
import { JKGame_PreloadScene } from './scenes/JKGame_PreloadScene'
import { JKGame_ProgressScene } from './scenes/JKGame_ProgressScene'
import { JKGame_ResultScene } from './scenes/JKGame_ResultScene'
import { JKGame_SettingsScene } from './scenes/JKGame_SettingsScene'
import { JKGame_ShopScene } from './scenes/JKGame_ShopScene'
import { JKGame_StoryScene } from './scenes/JKGame_StoryScene'

export function createGameConfig(parent: string): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO, // WebGL-first, Canvas fallback (Phaser 4)
    parent,
    backgroundColor: '#0b0e14',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: DESIGN_WIDTH,
      height: DESIGN_HEIGHT,
    },
    scene: [
      JKGame_PreloadScene,
      JKGame_BootScene,
      JKGame_MenuScene,
      JKGame_SettingsScene,
      JKGame_StoryScene,
      JKGame_GachaScene,
      JKGame_ShopScene,
      JKGame_CollectionScene,
      JKGame_ProgressScene,
      JKGame_LeaderboardScene,
      JKGame_ExploreScene,
      JKGame_CombatScene,
      JKGame_ResultScene,
    ],
  }
}
